import React from "react";
import {
  ListButton,
  SaveButton,
  Toolbar,
  useDataProvider,
  useNotify,
  useRedirect,
  useRefresh,
} from "react-admin";
import { useSelector } from "react-redux";
import {
  checkDiscountPreviousValue,
  checkDiscountValues,
  checkFillDiscount,
  checkFillDiscountRates,
  checkIsCash,
} from "../../helpers/checkDiscount";
import {
  checkCreditsDateError,
  checkIsDatesValid,
} from "../../helpers/checkDreamHome";
import { FixedOdds } from "../../types/fixedOdds";
import { Prize } from "../../types/prize";
import { TicketRatesDiscount } from "../../types/property";
import { CreditProps } from "../common/generalPickersBlocks/credits/CreditsPickerComponent";

const FixedOddsToolbar = (
  props,
  isCreate: boolean,
  handleImagesError: Function,
  discountFillError,
  setIsDiscountValidate,
  handleSetCountdownError,
  creditsData: {
    creditsArr: Array<CreditProps>;
    dateType: string;
    creditsStatus: boolean;
    creditsStartDate: Date | string | undefined;
    creditsEndDate: Date | string | undefined;
  },
  countdownStartDate: Date | string,
  countdownEndDate: Date | string,
  prize: Prize | undefined
) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const stateApp = useSelector((state) => state);
  const dataProvider = useDataProvider();

  const location = props.location.pathname.split("/");
  const path = location[location.length - 1] === "1" ? "1" : "";
  const id = props.id ? props.id + "/" : "create/";

  const handleSave = async (data) => {
    const images = stateApp.property.galleryFiles;
    const imagesMobile = stateApp.property.galleryFilesMobile;

    if (stateApp.property.isNew) {
      isCreate = true;
    }
    if (!images.length) {
      handleImagesError(true);
      notify("The form in not valid. Please check for errors", "error");
      return;
    }
    if (path === "") {
      redirect(`/fixedOdds/${id}1`);
      return;
    }
    if (!data.ticketPrice || !data.defaultTickets || !data.maxTickets) {
      setIsDiscountValidate(true);
      notify("The form in not valid. Please check for errors", "error");
      return;
    }

    if (prize && prize.ticketsBought) {
      if (prize.ticketsBought > data.maxTickets) {
        notify("max tickets should be less then already bought tickets", "error");
        return;
      }
    }

    const discountTicket = stateApp.property.ticketDiscount;
    let fixedOdds: FixedOdds = {
      discountCategory: data.discountCategory,
      description: data.description,
      defaultTickets: data.defaultTickets,
      ticketPrice: parseFloat(data.ticketPrice.toFixed(2)),
      title: data.title.replace(/\s+/g, ' ').trim(),
      isActiveDiscount: data.isActiveDiscount || false,
      active: data.active || false,
      id: data.id || "",
      photoUrlKeys: [],
      photoUrlKeysMobile:[],
      isTrending: data.isTrending || false,
      isPopular: data.isPopular || false,
      maxTickets: data.maxTickets,
      isDiscountRates: data.isDiscountRates,
      discountTicket: data.isActiveDiscount
        ? discountTicket
        : { percent: 1, newPrice: 1 },
      discountRates: data.isDiscountRates
        ? stateApp.property.discountRates
        : Array<TicketRatesDiscount>(),
      creditsRates: creditsData.creditsArr,
      isCreditsActive: creditsData.creditsStatus,
      creditsStartDate: creditsData.creditsStartDate,
      creditsEndDate: creditsData.creditsEndDate,
      startAt: countdownStartDate,
      endsAt: countdownEndDate,
      isCreditsPermanent: creditsData.dateType === "allDate" ? true : false,
      subtitle:data.subtitle,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription
    };
    if (fixedOdds.defaultTickets > fixedOdds.maxTickets) {
      notify("default tickets should be less then number of tickets", "error");
      return;
    }


    const isDiscountFillError = checkFillDiscount(
      fixedOdds.isActiveDiscount,
      fixedOdds.discountTicket
    );
    const isDiscountRatesFillError = checkFillDiscountRates(
      fixedOdds.isDiscountRates,
      fixedOdds.discountRates
    );
    const isPreviousValueError = checkDiscountPreviousValue(
      fixedOdds.discountRates
    );
    const isDiscountValueError = checkDiscountValues(
      fixedOdds.discountCategory,
      fixedOdds.discountRates
    );
    const isCreditsDateError = fixedOdds.isCreditsPermanent
      ? false
      : checkCreditsDateError(fixedOdds);
    const isCountdownDateError = checkIsDatesValid(
      fixedOdds.startAt,
      fixedOdds.endsAt
    );
    if (isCountdownDateError) {
      handleSetCountdownError(true);
    }

    if (
      isDiscountRatesFillError ||
      isPreviousValueError ||
      isDiscountValueError ||
      isDiscountFillError ||
      isCreditsDateError
    ) {
      discountFillError(true);
      notify("The form is not valid. Please check for errors", "error");
      return;
    }
    fixedOdds.discountRates = fixedOdds.isDiscountRates
      ? checkIsCash(data.discountCategory, stateApp.property.discountRates)
      : Array<TicketRatesDiscount>();
    try {
      const newFixedOdds = isCreate
        ? await dataProvider.create("fixedOdds", {
          data: fixedOdds,
        })
        : await dataProvider.update("fixedOdds", {
          data: fixedOdds,
          id: props.id,
          previousData: {} as any,
        });
      if (!newFixedOdds.data) {
        notify("something went wrong", "error");
      }
      const result = await dataProvider.storeImages(
        { source: "fixedOdds", id: newFixedOdds.data.result._id },
        {images,imagesMobile}
      );
      if (!result.data) {
        notify("something went wrong", "error");
      }

      await dataProvider.updateMostPopular({competitionType:"FIXED_ODDS", id:newFixedOdds.data.result._id, title:newFixedOdds.data.result.title });
      if (newFixedOdds.data.result.active && newFixedOdds.data.result.isTrending) {
        await dataProvider.addFeatured("FIXED_ODDS",newFixedOdds.data.result._id)
      } else {
        await dataProvider.removeFeatured("FIXED_ODDS",newFixedOdds.data.result._id)
      } 
      notify(`Fixed Odds ${isCreate ? "saved" : "updated"}`);
      redirect("/fixedOdds");
    } catch (error) {
      notify(error.data.error.toString().split(':')[1],"error");
    }
  };

  return (
    <Toolbar {...props} className="buttons-wrapper">
      <SaveButton className="save-button" onSave={handleSave} />
      <ListButton className="cancel-button" label="Cancel">
        <div>Cancel</div>
      </ListButton>
    </Toolbar>
  );
};

export default FixedOddsToolbar;

